export var SNAP_DISTANCE_FACTOR = 'snap';
export var FREQUENT_INTERVAL_THRESHOLD = 20;